import * as React from "react";
import SPservice from "../../../services/SPService";
import { ITag, Label, TagPicker } from "@fluentui/react";
import { IListItemPickerProps, IListItemPickerState } from ".";
import { isEqual } from '@microsoft/sp-lodash-subset';
import { LanguageContext } from "../../../../../utilities/LocalizationModule";
import { logger } from "../../../../../utilities/logger";
import { sortTerms } from "../../helpers/tagHelper";

export class ListItemPicker extends React.Component<IListItemPickerProps, IListItemPickerState> {
  private _spservice: SPservice;
  static contextType = LanguageContext;

  constructor(props: IListItemPickerProps) {
    super(props);

    this.state = {
      noresultsFoundText: !this.props.noResultsFoundText ? "No results found" : this.props.noResultsFoundText,
      showError: false,
      errorMessage: "",
      suggestionsHeaderText: !this.props.suggestionsHeaderText ? "Select value" : this.props.suggestionsHeaderText,
      selectedItems: props.defaultSelectedItems || []
    };

    this._spservice = new SPservice();
  }


  public componentWillReceiveProps(nextProps: IListItemPickerProps) {
    let newSelectedItems: any[] | undefined;
    if (this.props.listId !== nextProps.listId) {
      newSelectedItems = [];
    }
    if (!isEqual(this.props.defaultSelectedItems, nextProps.defaultSelectedItems)) {
      newSelectedItems = nextProps.defaultSelectedItems;
    }

    this.setState({
      selectedItems: newSelectedItems
    });
  }

  public render(): React.ReactElement<IListItemPickerProps> {
    const { className, disabled, itemLimit, placeholder } = this.props;
    const {
      suggestionsHeaderText,
      noresultsFoundText,
      errorMessage,
      selectedItems
    } = this.state;

    return (
      <div>
        <TagPicker
          resolveDelay={300}
          onResolveSuggestions={this.onFilterChanged}
          onEmptyResolveSuggestions={this.onGetDefaultSuggestions}
          getTextFromItem={this.getTextFromItem}
          pickerSuggestionsProps={{
            // suggestionsHeaderText: suggestionsHeaderText,
            noResultsFoundText: noresultsFoundText
          }}
          selectedItems={selectedItems}
          onChange={this.onItemChanged}
          className={className}
          itemLimit={itemLimit}
          disabled={disabled}
          inputProps={{
            placeholder: placeholder
          }} />

        {!!errorMessage &&
          (<Label style={{ color: '#FF0000' }}> {errorMessage} </Label>)}
      </div>
    );
  }

  private getTextFromItem(item: any): string {
    return item.name;
  }

  private onItemChanged = (selectedItems: { key: string; name: string }[]): void => {
    this.setState({
      selectedItems: selectedItems
    });
    this.props.onSelectedItem(selectedItems);
  }

  private onGetDefaultSuggestions = async (selectedItems?: ITag[]) => {
    return await this.onFilterChanged("*", selectedItems);
  }

  private onFilterChanged = async (filterText: string, selectedItems?: ITag[]) => {
    if (!filterText) return [];

    let resolvedSugestions: ITag[] = await this.loadListItems(filterText);

    // Filter out the already retrieved items, so that they cannot be selected again
    if (selectedItems && selectedItems.length > 0) {
      let filteredSuggestions = [];
      for (const suggestion of resolvedSugestions) {
        const exists = selectedItems.filter(sItem => sItem.key === suggestion.key);
        if (!exists || exists.length === 0) {
          filteredSuggestions.push(suggestion);
        }
      }
      resolvedSugestions = filteredSuggestions;
    }

    if (resolvedSugestions) {
      this.setState({
        errorMessage: "",
        showError: false
      });

      return sortTerms(filterText, resolvedSugestions);
    } else {
      return [];
    }
  }

  private loadListItems = async (filterText: string): Promise<ITag[]> => {
    let { listId, columnInternalName, keyColumnInternalName, webUrl, filter, substringSearch } = this.props;
    let arrayItems: ITag[] = [];
    let keyColumn: string = keyColumnInternalName || 'Id';

    try {
      let listItems = await this._spservice.getListItems(filterText, listId, columnInternalName, keyColumn, webUrl, filter, substringSearch);
      if (listItems.length > 0) {
        for (const item of listItems) {
          if (item[columnInternalName]) {
            arrayItems.push({ key: item[keyColumn], name: item[columnInternalName] });
          }
        }
      }
      return arrayItems;
    } catch (error) {
      logger(error, "ListItemPicker.tsx (loadListItems)");
      this.setState({
        showError: true,
        errorMessage: error.message,
        noresultsFoundText: error.message
      });
      return null;
    }
  }
}

